
export const PANEL_PADDING = 2;
